export enum ButtonSize
{
    normal,
    small,
    big
}